import { Sheet } from "@mui/joy";
import styled from "styled-components";
import TextTransition from "react-text-transition";
import { useState, useEffect } from "react";
import MovingText from "react-moving-text";

const CompanySpan = styled.span`
  font-size: 1.1em;
`;

const SelfImage = styled.img`
  margin: auto;
`;

const Hello = styled.h1`
  margin: 3% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "2.5vw" : "3.5vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
  width: max-content;
  height: ${(props) => (props.size.width >= 800 ? "3vw" : "4vw")};
`;

const Headline = styled.h1`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "3vw" : "6vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const Subtitle = styled.h2`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "2vw" : "3.5vw")};
  white-space: normal;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
`;

const AboutMe = (props) => {
  
  const dynamicWidth = () => {
    if (props.size.width >= 900) {
      return (props.size.width * 3) / 5;
    } else if (props.size.width >= 600) {
      return (props.size.width * 4) / 5;
    } else {
      return (props.size.width * 6) / 7;
    }
  };

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      1500 // every 1.5 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  const mainContainer = {
    borderRadius: 15,
    padding: 2,
    margin: "auto",
    marginTop: 2,
    width: dynamicWidth(),
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
    flexDirection: "row",
  };

  const childContainer = {
    borderRadius: 15,
    margin: [1, 0, 1, 1],
    display: "flex",
    justifyContent: "initial",
    flexDirection: "column",
    width: "max-content",
  };

  return (
    <div id={props.id}>
      <Sheet sx={mainContainer}>
        <Sheet sx={childContainer}>
          <Hello size={props.size}>
            <MovingText
              type="fadeInFromTop"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              <TextTransition>
                {props.hello[index % props.hello.length]}!
              </TextTransition>
            </MovingText>
          </Hello>
          <Headline size={props.size}>I'm {props.info.name}</Headline>
          <Subtitle size={props.size}>
            {props.info.subtitle}
            <CompanySpan>{props.info.company}</CompanySpan>
          </Subtitle>
        </Sheet>
        <Sheet sx={childContainer}>
          <SelfImage
            src={props.image}
            style={{ width: (dynamicWidth() * 3) / 10 }}
          />
        </Sheet>
      </Sheet>
    </div>
  );
};

export default AboutMe;
